/* eslint-disable react/no-unknown-property */
import {
  Skeleton,
} from '@doveit/bricks';
import React from 'react';
import * as styles from './MultimediaContentThumbnail.style';
import { MultimediaContentThumbnailProps } from './MultimediaContentThumbnail';

export type MultimediaContentThumbnailSkeletonProps = Pick<MultimediaContentThumbnailProps, 'aspectRatio'> & React.AriaAttributes;

const MultimediaContentThumbnailSkeleton: React.FC<MultimediaContentThumbnailSkeletonProps> = ({
  aspectRatio = '1 / 1',
  ...rest
}) => (
  <div
    css={styles.base}
    $aspectRatio={aspectRatio}
    role="button"
    {...rest}
  >
    <div
      css={styles.skeletonContent}
    >
      <Skeleton height="100%" />
    </div>
  </div>
);

export default MultimediaContentThumbnailSkeleton;
